import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// get the assigned locale
// this is stored by the coreStore but not initiallized yet so
// read directly from localStorage
let browserLang = navigator.language.split('-')[0]
export let language = localStorage.getItem('language') || browserLang

// this will be set on initial load - in loadLanguageAsync
export const loadedLanguages = [language]

const datetimeFormats = {
  en: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    },
    longlong: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    }
  },
  fr: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric'
    },
    longlong: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    }
  }
}

export const i18n = new VueI18n({
  locale: language,
  silentFallbackWarn: true,
  fallbackLocale: language,
  messages: loadLocaleMessages(),
  datetimeFormats: datetimeFormats
})

function setI18nLanguage (lang) {
  language = lang
  i18n.locale = lang
  localStorage.setItem('language', lang)
  // NOTE(msimonin): The selected language will be also set for axios
  // Accept-Language (see plugins/axios.js).
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

function loadLocaleMessages () {
  const locales = require.context(
    '../locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  )
  const messages = {}
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

// Run at load time and on lang change:
// This might be useful once the i18n is
// separated from the vue files
// see App.vue mount & coreServices.getAcceptLanguage
export async function loadLanguageAsync (lang, chunk) {
  let langFile = `${lang}`
  // !check fails the load
  // If the same language
  if (i18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang))
  }

  // For loading seperate language files
  // once consolodated files might be chunked for webpack loading
  /*
  if (chunk) {
    langFile = `${lang}_${chunk}`
  }
  */

  // If the language hasn't been loaded yet
  return import(
    /* webpackChunkName: 'locale-[request]' */ `@/locales/${langFile}`
  ).then((messages) => {
    i18n.setLocaleMessage(lang, messages.default)
    loadedLanguages.push(lang)
    i18n.messages[lang] = { ...i18n.messages[lang], ...messages.default }
    return setI18nLanguage(lang)
  })
}
